import { AuthLevel, generateApiPath } from '@guiker/api-definition'

const paths = {
  lease: generateApiPath({ prefix: AuthLevel.JWT_AUTH, name: 'lease' }),
}

export { paths }
